import * as THREE from 'three'
import Materials from './Materials.js'
import Floor from './Floor.js'
import Shadows from './Shadows.js'
import Physics from './Physics.js'
import Zones from './Zones.js'
import Objects from './Objects.js'
import Car from './Car.js'
import Areas from './Areas.js'
import Tiles from './Tiles.js'
import Walls from './Walls.js'
import IntroSection from './Sections/IntroSection.js'
import ProjectsSection from './Sections/ProjectsSection.js'
import CrossroadsSection from './Sections/CrossroadsSection.js'
import InformationSection from './Sections/InformationSection.js'
import PlaygroundSection from './Sections/PlaygroundSection.js'
// import DistinctionASection from './Sections/DistinctionASection.js'
// import DistinctionBSection from './Sections/DistinctionBSection.js'
// import DistinctionCSection from './Sections/DistinctionCSection.js'
// import DistinctionDSection from './Sections/DistinctionDSection.js'
import Controls from './Controls.js'
import Sounds from './Sounds.js'
import { TweenLite } from 'gsap/TweenLite'
import { Power2 } from 'gsap/EasePack'
import EasterEggs from './EasterEggs.js'

export default class
{
    constructor(_options)
    {
        // Опции
        this.config = _options.config
        this.debug = _options.debug
        this.resources = _options.resources
        this.time = _options.time
        this.sizes = _options.sizes
        this.camera = _options.camera
        this.renderer = _options.renderer
        this.passes = _options.passes

        // Дебаг
        if(this.debug)
        {
            this.debugFolder = this.debug.addFolder('world')
            this.debugFolder.open()
        }

        // Установки
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        // this.setAxes()
        this.setSounds()
        this.setControls()
        this.setFloor()
        this.setAreas()
        this.setStartingScreen()
    }

    start()
    {
        window.setTimeout(() =>
        {
            this.camera.pan.enable()
        }, 2000)

        this.setReveal()
        this.setMaterials()
        this.setShadows()
        this.setPhysics()
        this.setZones()
        this.setObjects()
        this.setCar()
        this.areas.car = this.car
        this.setTiles()
        this.setWalls()
        this.setSections()
        this.setEasterEggs()
    }

    setReveal()
    {
        this.reveal = {}
        this.reveal.matcapsProgress = 0
        this.reveal.floorShadowsProgress = 0
        this.reveal.previousMatcapsProgress = null
        this.reveal.previousFloorShadowsProgress = null

        // Go method
        this.reveal.go = () =>
        {
            TweenLite.fromTo(this.reveal, 3, { matcapsProgress: 0 }, { matcapsProgress: 1 })
            TweenLite.fromTo(this.reveal, 3, { floorShadowsProgress: 0 }, { floorShadowsProgress: 1, delay: 0.5 })
            TweenLite.fromTo(this.shadows, 3, { alpha: 0 }, { alpha: 0.5, delay: 0.5 })

            if(this.sections.intro)
            {
                TweenLite.fromTo(this.sections.intro.instructions.arrows.label.material, 0.3, { opacity: 0 }, { opacity: 1, delay: 0.5 })
                if(this.sections.intro.otherInstructions)
                {
                    TweenLite.fromTo(this.sections.intro.otherInstructions.label.material, 0.3, { opacity: 0 }, { opacity: 1, delay: 0.75 })
                }
            }

            // Car
            this.physics.car.chassis.body.sleep()
            this.physics.car.chassis.body.position.set(0, 0, 12)

            window.setTimeout(() =>
            {
                this.physics.car.chassis.body.wakeUp()
            }, 300)

            // Sound
            TweenLite.fromTo(this.sounds.engine.volume, 0.5, { master: 0 }, { master: 0.7, delay: 0.3, ease: Power2.easeIn })
            window.setTimeout(() =>
            {
                this.sounds.play('reveal')
            }, 400)

            // Controls
            if(this.controls.touch)
            {
                window.setTimeout(() =>
                {
                    this.controls.touch.reveal()
                }, 400)
            }
        }

        // Временная шкала
        this.time.on('tick',() =>
        {
            // Matcap progress changed
            if(this.reveal.matcapsProgress !== this.reveal.previousMatcapsProgress)
            {
                // Update each material
                for(const _materialKey in this.materials.shades.items)
                {
                    const material = this.materials.shades.items[_materialKey]
                    material.uniforms.uRevealProgress.value = this.reveal.matcapsProgress
                }

                // Сохраняем
                this.reveal.previousMatcapsProgress = this.reveal.matcapsProgress
            }

            // Matcap progress changed
            if(this.reveal.floorShadowsProgress !== this.reveal.previousFloorShadowsProgress)
            {
                // Update each floor shadow
                for(const _mesh of this.objects.floorShadows)
                {
                    _mesh.material.uniforms.uAlpha.value = this.reveal.floorShadowsProgress
                }

                // Сохраняем
                this.reveal.previousFloorShadowsProgress = this.reveal.floorShadowsProgress
            }
        })

        // Дебаг
        if(this.debug)
        {
            this.debugFolder.add(this.reveal, 'matcapsProgress').step(0.0001).min(0).max(1).name('matcapsProgress')
            this.debugFolder.add(this.reveal, 'floorShadowsProgress').step(0.0001).min(0).max(1).name('floorShadowsProgress')
            this.debugFolder.add(this.reveal, 'go').name('reveal')
        }
    }

    setStartingScreen()
    {
        this.startingScreen = {}

        // Зона
        this.startingScreen.area = this.areas.add({
            position: new THREE.Vector2(0, 0),
            halfExtents: new THREE.Vector2(2.35, 1.5),
            hasKey: false,
            testCar: false,
            active: false
        })

        // Текст лоадинг
        this.startingScreen.loadingLabel = {}
        this.startingScreen.loadingLabel.geometry = new THREE.PlaneBufferGeometry(2.5, 2.5 / 4)
        this.startingScreen.loadingLabel.image = new Image()
        this.startingScreen.loadingLabel.image.src = 'data:image/png;base64,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'
        this.startingScreen.loadingLabel.texture = new THREE.Texture(this.startingScreen.loadingLabel.image)
        this.startingScreen.loadingLabel.texture.magFilter = THREE.NearestFilter
        this.startingScreen.loadingLabel.texture.minFilter = THREE.LinearFilter
        this.startingScreen.loadingLabel.texture.needsUpdate = true
        this.startingScreen.loadingLabel.material = new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.startingScreen.loadingLabel.texture })
        this.startingScreen.loadingLabel.mesh = new THREE.Mesh(this.startingScreen.loadingLabel.geometry, this.startingScreen.loadingLabel.material)
        this.startingScreen.loadingLabel.mesh.matrixAutoUpdate = false
        this.container.add(this.startingScreen.loadingLabel.mesh)

        // Текст старт
        this.startingScreen.startLabel = {}
        this.startingScreen.startLabel.geometry = new THREE.PlaneBufferGeometry(2.5, 2.5 / 4)
        this.startingScreen.startLabel.image = new Image()
        this.startingScreen.startLabel.image.src = 'data:image/png;base64,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'
        this.startingScreen.startLabel.texture = new THREE.Texture(this.startingScreen.startLabel.image)
        this.startingScreen.startLabel.texture.magFilter = THREE.NearestFilter
        this.startingScreen.startLabel.texture.minFilter = THREE.LinearFilter
        this.startingScreen.startLabel.texture.needsUpdate = true
        this.startingScreen.startLabel.material = new THREE.MeshBasicMaterial({ transparent: true, depthWrite: false, color: 0xffffff, alphaMap: this.startingScreen.startLabel.texture })
        this.startingScreen.startLabel.material.opacity = 0
        this.startingScreen.startLabel.mesh = new THREE.Mesh(this.startingScreen.startLabel.geometry, this.startingScreen.startLabel.material)
        this.startingScreen.startLabel.mesh.matrixAutoUpdate = false
        this.container.add(this.startingScreen.startLabel.mesh)

        // Progress
        this.resources.on('progress', (_progress) =>
        {
            // Update area
            this.startingScreen.area.floorBorder.material.uniforms.uAlpha.value = 1
            this.startingScreen.area.floorBorder.material.uniforms.uLoadProgress.value = _progress
        })

        // Ready
        this.resources.on('ready', () =>
        {
            window.requestAnimationFrame(() =>
            {
                this.startingScreen.area.activate()

                TweenLite.to(this.startingScreen.area.floorBorder.material.uniforms.uAlpha, 0.3, { value: 0.3 })
                TweenLite.to(this.startingScreen.loadingLabel.material, 0.3, { opacity: 0 })
                TweenLite.to(this.startingScreen.startLabel.material, 0.3, { opacity: 1, delay: 0.3 })
            })
        })

        // On interact, reveal
        this.startingScreen.area.on('interact', () =>
        {
            this.startingScreen.area.deactivate()
            TweenLite.to(this.startingScreen.area.floorBorder.material.uniforms.uProgress, 0.3, { value: 0, delay: 0.4 })

            TweenLite.to(this.startingScreen.startLabel.material, 0.3, { opacity: 0, delay: 0.4 })

            this.start()

            window.setTimeout(() =>
            {
                this.reveal.go()
            }, 600)
        })
    }

    setSounds()
    {
        this.sounds = new Sounds({
            debug: this.debugFolder,
            time: this.time
        })
    }

    setAxes()
    {
        this.axis = new THREE.AxesHelper()
        this.container.add(this.axis)
    }

    setControls()
    {
        this.controls = new Controls({
            config: this.config,
            sizes: this.sizes,
            time: this.time,
            camera: this.camera,
            sounds: this.sounds
        })
    }

    setMaterials()
    {
        this.materials = new Materials({
            resources: this.resources,
            debug: this.debugFolder
        })
    }

    setFloor()
    {
        this.floor = new Floor({
            debug: this.debugFolder
        })

        this.container.add(this.floor.container)
    }

    setShadows()
    {
        this.shadows = new Shadows({
            time: this.time,
            debug: this.debugFolder,
            renderer: this.renderer,
            camera: this.camera
        })
        this.container.add(this.shadows.container)
    }

    setPhysics()
    {
        this.physics = new Physics({
            config: this.config,
            debug: this.debug,
            time: this.time,
            sizes: this.sizes,
            controls: this.controls,
            sounds: this.sounds
        })

        this.container.add(this.physics.models.container)
    }

    setZones()
    {
        this.zones = new Zones({
            time: this.time,
            physics: this.physics,
            debug: this.debugFolder
        })
        this.container.add(this.zones.container)
    }

    setAreas()
    {
        this.areas = new Areas({
            config: this.config,
            resources: this.resources,
            debug: this.debug,
            renderer: this.renderer,
            camera: this.camera,
            car: this.car,
            sounds: this.sounds,
            time: this.time
        })

        this.container.add(this.areas.container)
    }

    setTiles()
    {
        this.tiles = new Tiles({
            resources: this.resources,
            objects: this.objects,
            debug: this.debug
        })
    }

    setWalls()
    {
        this.walls = new Walls({
            resources: this.resources,
            objects: this.objects
        })
    }

    setObjects()
    {
        this.objects = new Objects({
            time: this.time,
            resources: this.resources,
            materials: this.materials,
            physics: this.physics,
            shadows: this.shadows,
            sounds: this.sounds,
            debug: this.debugFolder
        })
        this.container.add(this.objects.container)

        // window.requestAnimationFrame(() =>
        // {
        //     this.objects.merge.update()
        // })
    }

    setCar()
    {
        this.car = new Car({
            time: this.time,
            resources: this.resources,
            objects: this.objects,
            physics: this.physics,
            shadows: this.shadows,
            materials: this.materials,
            controls: this.controls,
            sounds: this.sounds,
            renderer: this.renderer,
            camera: this.camera,
            debug: this.debugFolder,
            config: this.config
        })
        this.container.add(this.car.container)
    }

    setSections()
    {
        this.sections = {}

        // Generic options
        const options = {
            config: this.config,
            time: this.time,
            resources: this.resources,
            camera: this.camera,
            passes: this.passes,
            objects: this.objects,
            areas: this.areas,
            zones: this.zones,
            walls: this.walls,
            tiles: this.tiles,
            debug: this.debugFolder
        }

        // // Отличие А
        // this.sections.distinctionA = new DistinctionASection({
        //     ...options,
        //     x: 0,
        //     y: - 15
        // })
        // this.container.add(this.sections.distinctionA.container)

        // // Отличие B
        // this.sections.distinctionB = new DistinctionBSection({
        //     ...options,
        //     x: 0,
        //     y: - 15
        // })
        // this.container.add(this.sections.distinctionB.container)

        // // Отличие C
        // this.sections.distinctionC = new DistinctionCSection({
        //     ...options,
        //     x: 0,
        //     y: 0
        // })
        // this.container.add(this.sections.distinctionC.container)

        // // Distinction D
        // this.sections.distinctionD = new DistinctionDSection({
        //     ...options,
        //     x: 0,
        //     y: 0
        // })
        // this.container.add(this.sections.distinctionD.container)

        // Интро
        this.sections.intro = new IntroSection({
            ...options,
            x: 0,
            y: 0
        })
        this.container.add(this.sections.intro.container)

        // Перекрёсток
        this.sections.crossroads = new CrossroadsSection({
            ...options,
            x: 0,
            y: - 30
        })
        this.container.add(this.sections.crossroads.container)

        // Проекты
        this.sections.projects = new ProjectsSection({
            ...options,
            x: 30,
            y: - 30
            // x: 0,
            // y: 0
        })
        this.container.add(this.sections.projects.container)

        // Информация
        this.sections.information = new InformationSection({
            ...options,
            x: 1.2,
            y: - 55
            // x: 0,
            // y: - 10
        })
        this.container.add(this.sections.information.container)

        // Игровая площадка
        this.sections.playground = new PlaygroundSection({
            ...options,
            x: - 38,
            y: - 34
            // x: - 15,
            // y: - 4
        })
        this.container.add(this.sections.playground.container)
    }

    setEasterEggs()
    {
        this.easterEggs = new EasterEggs({
            resources: this.resources,
            car: this.car,
            walls: this.walls,
            objects: this.objects,
            materials: this.materials,
            areas: this.areas,
            config: this.config
        })
        this.container.add(this.easterEggs.container)
    }
}
